import React from 'react';
import { Route, Switch } from 'react-router-dom';
import useReactRouter from 'use-react-router';

import Authorize from '../layout/Authorize';
import Layout from '../layout/Root';
import Processing from './Processing';
import StockOrder from './StockOrder';
import RxOrder from './RxOrder';
import StockOrderContainer from "../../containers/StockOrder";
import RxOrderContainer from "../../containers/RxOrder";

export default (() => {

  const { match } = useReactRouter();

  return (
    <Authorize>
      <StockOrderContainer.Provider>
        <RxOrderContainer.Provider>
          <Layout>
            <Switch>
              <Route path={`${match.url}/processing`} component={Processing} />
              <Route path={`${match.url}/stock-order`} component={StockOrder} />
              <Route path={`${match.url}/rx-order`} component={RxOrder} />
            </Switch>
          </Layout>
        </RxOrderContainer.Provider>
      </StockOrderContainer.Provider>
    </Authorize>
  )
}) as React.FC;
